import React from 'react';
import { format as formatDate, formatISO, parseISO } from 'date-fns';
import { isDate } from 'lodash';

const timeFormat = 'HH:mm';

const shortDateFormat = 'dd/MM/y';
const mediumDateFormat = 'dd MMM yyyy';
const longDateFormat = 'dd MMMM yyyy';

const getDateFormat = (format: 'short' | 'medium' | 'long') => {
  if (format === 'medium') {
    return mediumDateFormat;
  } else if (format === 'long') {
    return longDateFormat;
  }

  return shortDateFormat;
};

export type TimeProps = {
  value: Date | string;
  type?: 'date' | 'time' | 'complete';
  representation?: 'date' | 'time' | 'complete';
  format?: 'short' | 'medium' | 'long';
};

export const Time = ({
  value,
  type = 'complete',
  format = 'short',
  representation = type,
}: TimeProps) => {
  const date = isDate(value) ? value : parseISO(value);
  const getFormattedContent = () => {
    if (representation === 'date') {
      return formatDate(date, getDateFormat(format));
    } else if (representation === 'time') {
      return formatDate(date, timeFormat);
    } else {
      return formatDate(date, `${getDateFormat(format)} ${timeFormat}`);
    }
  };

  return (
    <time
      dateTime={formatISO(date, {
        representation,
      })}
      title={
        type === 'complete' && representation !== 'complete'
          ? formatDate(date, `${getDateFormat(format)} ${timeFormat}`)
          : undefined
      }
    >
      {getFormattedContent()}
    </time>
  );
};
